export default __webpack_public_path__ + "static/media/cavemenClashing2x.223ef25c.png";